export default __webpack_public_path__ + "static/media/p66.6f6aa0b2.jpg";